  /**
   * @memberof rmOBA
   * @ngdoc directive
   * @name rmBlurOnEnter
   * @description
   *   Blur a form element when a user presses the enter key. 
   *   This is to get around issue where tooltips persist on add postage product modal when user hits enter to complete.
   *
   * @example
   *   Usage:
   *        <input rm-blur-on-enter />
   */

angular.module('rmOBA').directive('rmBlurOnEnter', function() {
    return function(scope, element, attrs) {
        element.bind("keydown, keypress", function(event) {
            if(event.which === 13) {
                scope.$apply(function(){
                    event.target.blur();
                });
            }
        });
    };
});